import { MutationOptions, useMutation, useQueryClient } from "react-query";
import { APIError, APIResponse, postFormData } from "../api";
import { API_URL } from "../api";

function useProfileUpdate<T>(
  options?: MutationOptions<APIResponse<T>, APIError, Record<any, any>>
) {
  const client = useQueryClient();
  const {
    isLoading: updatingProfile,
    isError: isProfileUpdateError,
    error: profileUpdateError,
    mutate: updateProfile,
  } = useMutation(
    (variables: Record<any, any>) => {
      const url = API_URL + "/account/user/account/update";

      const formData = new FormData();

      if (variables.profile_pics) {
        formData.append(
          "photo",
          variables.profile_pics.file,
          variables.profile_pics.name
        ); // Replace with your actual file data if you need to upload an image
      }

      if (variables.address !== undefined && variables.address !== null) {
        formData.append("address", variables.address);
      }

      // Identity fields are only sent when the caller explicitly provides them
      // (used to let users backfill details missing on legacy accounts, e.g.
      // date_of_birth/firstname/lastname). The backend update endpoint accepts
      // each of these and falls back to the existing value when absent.
      (
        [
          "firstname",
          "lastname",
          "middlename",
          "gender",
          "place_of_birth",
          "date_of_birth",
        ] as const
      ).forEach((key) => {
        if (variables[key] !== undefined && variables[key] !== null) {
          formData.append(key, variables[key]);
        }
      });

      const headers = {
        accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };

      const options = {
        headers: headers,
      };

      return postFormData(url, formData, options);
    },
    {
      ...options,
      onSettled() {
        client.invalidateQueries("profile");
      },
    }
  );

  return {
    updateProfile,
    isProfileUpdateError,
    profileUpdateError,
    updatingProfile,
  };
}

export default useProfileUpdate;
